module.exports = __webpack_public_path__ + "static/media/iq.e065a7ce.svg";